import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static values = {
    interval: { type: Number, default: 2500 },
    state: String
  }

  connect() {
    if (this.stateValue === "ready") {
      Turbo.visit(window.location.href, { action: "replace" })
      return
    }

    if (this.stateValue === "processing") {
      this.timer = setTimeout(() => {
        Turbo.visit(window.location.href, { action: "replace" })
      }, this.intervalValue)
    }
  }

  disconnect() {
    if (this.timer) clearTimeout(this.timer)
  }
}
